import {  Component, OnInit } from '@angular/core';
import { CnafContacterMaCafService } from '../../../services/contactermacaf.service';
import { Router } from '@angular/router';
import { ContactermacafMotifsdecontactComponent } from '../../contactermacaf-motifsdecontact.component';

@Component({
  selector: 'app-contactermacaf-motifsdecontact-autremotif',
  templateUrl: 'motifsdecontact-autremotif.component.html',
  styleUrls: ['../../contactermacaf-motifsdecontact.component.css']
})
export class MotifsdecontactAutremotifComponent extends ContactermacafMotifsdecontactComponent implements OnInit {

  constructor(
    private _router: Router,
    private _cnafContacterMaCafService: CnafContacterMaCafService
  ) {
    super(_router,_cnafContacterMaCafService);
  }

  ngOnInit(): void {
    this.chapitre3 = 'autre_motif';
    super.ngOnInit();
  }
}
